// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__648jw","button":"Popup_button__ovjIe","overlay":"Popup_overlay__SuqRd","message":"Popup_message__NvNLs"};